"use client";

import axios from "axios";
import React, { useEffect, useState } from "react";
import Spinner from "@/ui/Spinner";
import { ProductList } from "@/ui/components/ProductList";
import { type ImageSummary } from "@/ui/types";

const API_URL = process.env.NEXT_PUBLIC_MICROGRAPHER_API_URL;
const API_KEY = process.env.NEXT_PUBLIC_MICROGRAPHER_API_KEY;

export function Shop() {
	const [products, setProducts] = useState<ImageSummary[]>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		axios
			.get<ImageSummary[]>(`${API_URL}/products`, {
				headers: { "x-api-key": API_KEY },
			})
			.then((res) => {
				// New contract: GET /products returns an array of ImageSummary.
				setProducts(Array.isArray(res.data) ? res.data : []);
			})
			.catch((error) => {
				console.error("Error fetching products:", error);
				setIsError(true);
			})
			.finally(() => {
				setIsLoading(false);
			});
	}, []);

	return (
		<div className="bg-bone">
			{/* Curatorial intro (DESIGN.md §4.2 / R.3.3) */}
			<header className="mx-auto max-w-gallery px-5 pt-section-sm sm:px-8">
				<p className="label-caps mb-5 text-ink-muted">The Collection</p>
				<h1 className="max-w-3xl font-serif text-display font-light text-mg-black">
					Substances, crystallized and rendered as light.
				</h1>
				<p className="mt-6 max-w-prose text-ink-muted">
					Each print is a single, unrepeatable crystallization — photographed under polarized light, printed
					on cotton rag, signed, and issued in a limited edition. Browse by collection below.
				</p>
			</header>

			<section className="mx-auto max-w-gallery px-5 py-section sm:px-8">
				<h2 className="sr-only">Prints</h2>
				{isLoading ? (
					<Spinner />
				) : isError ? (
					<p className="py-section-sm text-center text-ink-muted">
						We couldn&apos;t load the collection right now. Please refresh or try again shortly.
					</p>
				) : products.length === 0 ? (
					<p className="py-section-sm text-center text-ink-muted">
						New editions are in preparation. Please check back soon.
					</p>
				) : (
					<ProductList products={products} />
				)}
			</section>
		</div>
	);
}
